import { useEffect } from "react";
import { Link } from "react-router-dom";

const values = [
  { title: "Rooted in Craft", body: "Chikankari, handloom weaves and hand-finished detailing — every piece carries the fingerprint of an Indian artisan." },
  { title: "Quietly Contemporary", body: "We strip away the ornate excess and let clean silhouettes and refined fabric speak. Heritage, made wearable." },
  { title: "Made to Last", body: "Considered construction and natural fibres — clothing meant to be worn, loved and passed on." },
];

export default function About() {
  useEffect(() => { document.title = "Our Story — KKashigari India"; window.scrollTo(0, 0); }, []);
  return (
    <div data-testid="about-page">
      <section className="relative h-[60vh] min-h-[420px] overflow-hidden">
        <img src="https://images.unsplash.com/photo-1727835523550-18478cacefa2?crop=entropy&cs=srgb&fm=jpg&q=85" alt="KKashigari" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#2b2415]/45" />
        <div className="relative h-full max-w-[1400px] mx-auto px-5 lg:px-10 flex flex-col justify-center">
          <div className="uplabel text-[#FBF7DE] mb-3">The KKashigari Story</div>
          <h1 className="font-serif text-5xl sm:text-6xl text-[#FBF7DE] max-w-2xl leading-tight">A haveli, reimagined for today.</h1>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-5 py-20 lg:py-28 text-center">
        <p className="font-serif text-2xl sm:text-3xl text-[var(--bronze)] leading-relaxed">
          KKashigari began with a simple belief — that Indian ethnic wear could be both deeply rooted and effortlessly modern.
        </p>
        <p className="text-[var(--olive)] mt-8 leading-relaxed text-lg">
          Named for the artistry of Kashi, our kurtas and kurta sets are built around handwoven fabrics and quiet craftsmanship.
          We work closely with artisan clusters across India, honouring age-old techniques while designing for the man and boy of today —
          someone who values elegance without excess, and heritage without heaviness.
        </p>
      </section>

      <section className="max-w-[1400px] mx-auto px-5 lg:px-10 pb-20 lg:pb-28">
        <div className="grid md:grid-cols-3 gap-px bg-[var(--line)] border border-[var(--line)]">
          {values.map((v) => (
            <div key={v.title} className="bg-[#FBF7DE] p-10">
              <h3 className="font-serif text-2xl text-[var(--bronze)]">{v.title}</h3>
              <p className="text-[var(--olive)] mt-4 leading-relaxed">{v.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="grid lg:grid-cols-2">
        <div className="bg-[var(--bronze)] flex items-center px-8 lg:px-20 py-24">
          <div className="max-w-md">
            <div className="uplabel text-[#FBF7DE]/70 mb-4">Our Promise</div>
            <h2 className="font-serif text-4xl text-[#FBF7DE] leading-tight">Craftsmanship you can feel, elegance you can wear.</h2>
            <Link to="/shop" className="inline-block mt-8 uplabel text-[#FBF7DE] link-underline">Explore The Collection</Link>
          </div>
        </div>
        <div className="relative min-h-[380px]">
          <img src="https://images.unsplash.com/photo-1652722464455-ec026ef74703?crop=entropy&cs=srgb&fm=jpg&q=85" alt="Craft" className="absolute inset-0 w-full h-full object-cover" />
        </div>
      </section>
    </div>
  );
}
